import "./works.scss"

export default function Works() {
    return (
        <div className="works" id="works">
            
        </div>
    )
}
